export default "/logo-drug-science.png";